// Shared channel/tone display names — keep in sync everywhere a channel or tone key is shown to a non-technical user.
export const CHANNEL_NAMES = {
  whatsapp: 'WhatsApp',
  web_chat: 'Chat web',
  email: 'Correo',
  voice: 'Llamada de voz',
  sms: 'SMS',
  instagram: 'Instagram',
  facebook: 'Facebook Messenger',
  telegram: 'Telegram',
  unknown: 'Otro',
};

export function friendlyChannelName(key) {
  return CHANNEL_NAMES[key] || key;
}

export const TONE_NAMES = {
  professional: 'Profesional',
  friendly: 'Amigable',
  formal: 'Formal',
  casual: 'Relajado',
  empathetic: 'Empático',
};

export function friendlyToneName(key) {
  return TONE_NAMES[key] || key;
}
